/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Options/Active/Post
 * @desc Active node component for date
 */

import { getNameAndIcon } from 'labstep-web/components/Filter/ResourceItemStatus/Active/utils';
import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { FilterPostNewIndexOptions } from 'labstep-web/components/FilterPost/NewIndex/Options';
import { useParamsContext } from 'labstep-web/contexts/params/hook';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import { QueryParameterService } from 'labstep-web/services/query-parameter.service';
import type React from 'react';
import { getPostFilterOptions } from '../../Form';

export const FilterPostNewIndexOptionsActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick, entityView }) => {
  const TEXT_FILTERS = [
    getPostFilterOptions('availability', PostFilterComparison.eq),
    getPostFilterOptions('status', PostFilterComparison.eq),
  ];
  const { addPostFilter } = useParamsContext();
  const filterActive = TEXT_FILTERS.find((filter) =>
    filter.isNodeActive(node),
  );
  if (!filterActive) {
    return null;
  }

  if (
    QueryParameterService.isPostFilterNodeType(node.predicates[0])
  ) {
    const path = filterActive.getPath() || undefined;
    const attributes = filterActive.getAttributeValues(node);
    const label = node.predicates[0].attribute;
    const field = Object.keys(attributes)[0];
    const value = node.predicates[0].value;

    const postFilterSettings = {
      label,
      path,
      field,
    };

    return (
      <FilterPostNewIndexOptions
        label={label}
        path={postFilterSettings.path}
        field={postFilterSettings.field}
        addPostFilter={addPostFilter}
        viewComponent={({ toggleModal }) => (
          <RemoveLabel
            {...getNameAndIcon(value as string)}
            onNameClick={toggleModal}
            onRemoveClick={onRemoveClick}
          />
        )}
        entityName={entityView ? entityView.entity_name : ''}
      />
    );
  }
  return null;
};
